module.exports = __webpack_public_path__ + "img/taiwan.c65c54ae.png";